<template>
    <div class="wrapper">
        <transition name="fade">
            <div v-for="(item, index) in items" class="img-background" :style="'background-image: url('+item.imgUrl+')'"
                 v-if="activeItem === index" :key="'item_'+index">
                <div class="filter-gray"></div>
                <div class="lds-ring" v-if="loadingVideo">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </transition>
        <div class="tv">
            <div class="filter-gray"></div>
            <div class="screen mute" id="tv">

            </div>
        </div>


        <div class="container">
            <div class="swiper-over-container">

                <div class="custom-loader" :class="loaderClass" @click="stopTimer()">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <span class="icon-close" v-if="showStopTimer"></span>
                </div>

                <div class="swiper-container home-focus-swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in items">
                            <div class="wrap-content">
                                <a :href="item.url" class="titre" v-html="item.titre"></a>
                                <p class="desc" v-html="item.extrait"></p>
                                <span class="icon-arrow-right"></span>
                            </div>
                        </div>
                    </div>
                    <div class="wrap-bar"></div>
                </div>

            </div>

        </div>
    </div>


</template>

<script>
    import $ from "jquery";
    import YoutubePlayer from "../../mixins/YoutubePlayer"
    import Swiper from "swiper"

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            }
        },
        mixins: [YoutubePlayer],
        data() {
            return {
                focusSwiperInstance: null,
                activeItem: null,
                activeTypeVideo: false,
                okClickSlide: true,
                timerPercent: 0,
                autoplayDelay: 8000,
                refreshTime: 200,
                timerInterval: null,
            };
        },
        computed: {
            showStopTimer(){
                if (this.focusSwiperInstance && this.focusSwiperInstance.autoplay.running){
                    return true
                }else{
                    return false
                }
            },
            loaderClass() {
                var output = "percent-"

                if (this.timerPercent === 0) {
                    output += "0"
                } else if (this.timerPercent <= 12.5) {
                    output += "1"
                } else if (this.timerPercent <= 25) {
                    output += "2"
                } else if (this.timerPercent <= 37.5) {
                    output += "3"
                } else if (this.timerPercent <= 50) {
                    output += "4"
                } else if (this.timerPercent <= 62.5) {
                    output += "5"
                } else if (this.timerPercent <= 75) {
                    output += "6"
                } else if (this.timerPercent <= 87.5) {
                    output += "7"
                } else if (this.timerPercent <= 100) {
                    output += "8"
                }

                if (this.showStopTimer){
                    output += " active"
                }

                return output
            }
        },
        methods: {
            initSwiper() {
                this.focusSwiperInstance = new Swiper(".home-focus-swiper", {
                    direction: "vertical",
                    slidesPerView: 5,
                    // spaceBetween:20,
                    centeredSlides: true,
                    loop: true,
                    // loopAdditionalSlides: 30,
                    simulateTouch: false,
                    allowTouchMove:false,
                    autoplay: {
                        delay: this.autoplayDelay,
                        disableOnInteraction: false
                    },
                    // watchOverflow:true,
                    on: {
                        init: () => {
                            this.initClickEvents()
                        },
                        slideChangeTransitionStart: () => {
                            clearInterval(this.timerInterval)
                            this.$nextTick(function () {
                                $(".home-focus-swiper .swiper-slide").removeClass("prev-prev")

                                let $activeSlide = $(".home-focus-swiper .swiper-slide-active")
                                let actualIndex = null
                                for (let pas = 0; pas < this.focusSwiperInstance.slides.length; pas++) {
                                    if (this.focusSwiperInstance.slides[pas] === $activeSlide[0]) {
                                        actualIndex = pas
                                    }
                                }
                                let targetIndex = actualIndex - 2
                                $(this.focusSwiperInstance.slides[targetIndex]).addClass("prev-prev")
                                this.showAttachement()

                            })
                        },
                        slideChangeTransitionEnd: () => {

                            // console.log("slideChangeTransitionEnd")
                            if (this.focusSwiperInstance && !this.focusSwiperInstance.autoplay.running){
                                this.focusSwiperInstance.autoplay.start()
                            }
                            this.timerPercent = 0

                            let nbrFois = (this.autoplayDelay / this.refreshTime)
                            let offset = ((this.autoplayDelay / nbrFois) * 100) / this.autoplayDelay
                            this.timerInterval = setInterval(() => {
                                this.timerPercent = this.timerPercent + offset
                            }, this.refreshTime)
                        },

                    }
                });
            },
            initClickEvents() {
                $(document).on("click", ".home-focus-swiper .swiper-slide .titre", event => {

                    if (!this.okClickSlide) {
                        return
                    }
                    this.okClickSlide = false
                    clearInterval(this.timerInterval)
                    this.timerPercent = 0

                    // Check if clicked slide is not focused slide
                    let $slide = $(event.currentTarget).closest(".swiper-slide")
                    if (!$slide.hasClass("swiper-slide-active")) {
                        event.preventDefault()
                    } else {
                        window.location = $slide.find(".titre").attr("href")
                        return
                    }

                    // Get target index
                    let targetIndex = null
                    for (let pas = 0; pas < this.focusSwiperInstance.slides.length; pas++) {
                        if (this.focusSwiperInstance.slides[pas] === $slide[0]) {
                            targetIndex = pas
                        }
                    }

                    // get actual index
                    let $activeSlide = $(".home-focus-swiper .swiper-slide-active")

                    let actualIndex = null
                    for (let pas = 0; pas < this.focusSwiperInstance.slides.length; pas++) {
                        if (this.focusSwiperInstance.slides[pas] === $activeSlide[0]) {
                            actualIndex = pas
                        }
                    }

                    // get offset
                    let offsetIndex = actualIndex - targetIndex;
                    //get direction
                    let direction = "forward"
                    if (offsetIndex > 0) {
                        direction = "backward"
                    }

                    // positiving offset
                    offsetIndex = Math.abs(offsetIndex)

                    // Handle slide change.
                    for (let pas = 0; pas < offsetIndex; pas++) {
                        setTimeout(() => {
                            let doEvents = false
                            if (pas === offsetIndex - 1) {
                                doEvents = true
                            }

                            if (direction === "forward") {
                                this.focusSwiperInstance.slideNext(150, doEvents)
                            } else {
                                this.focusSwiperInstance.slidePrev(150, doEvents)
                            }

                        }, pas * 200)
                    }

                    // ReActivate click hability after animation
                    setTimeout(() => {
                        this.okClickSlide = true
                    }, offsetIndex * 200)


                });

                $(document).on("click", ".home-focus-swiper .swiper-slide-active .wrap-content", event => {
                    let $slide = $(event.currentTarget).closest(".swiper-slide")
                    window.location = $slide.find(".titre").attr("href")
                    return
                });

            },
            showAttachement() {
                let activeItemIndex = this.focusSwiperInstance.realIndex
                let activeItem = this.items[activeItemIndex]
                this.loadingVideo = false

                if (activeItem.videoID) {
                    this.showImgBack(activeItemIndex)
                    this.initVid(activeItem)
                    this.activeTypeVideo = true
                    return
                } else {
                    this.hidePlayer()
                    this.showImgBack(activeItemIndex)
                    this.activeTypeVideo = false


                }
            },
            showImgBack(activeItemIndex) {
                this.activeItem = activeItemIndex
            },
            stopTimer(){
                clearInterval(this.timerInterval)
                this.timerPercent = 0
                this.focusSwiperInstance.autoplay.stop()
            }

        },
        created(){
          this.autoplayDelay = this.items[0].timer * 1000
        },
        mounted() {
            this.initSwiper()

        },
        destroyed() {
        }
    };
</script>
